import { useState, useRef } from "react";
import MspReportTable from "../../../sec-stack-report/report-page/msp-report-list/report-table/index";
import ReportSearchFilter from "../../../sec-stack-report/report-page/report-search-filter";
import { mockTableData } from "./mock-table-data";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";

const StackReportSection = () => {
  const navigate = useNavigate();
  const mockMspId = "msp-123";
  const SearchInput = useRef();
  const [searchString, setSearchString] = useState('');

  const handleReportAdd = () => {
    navigate(ROUTE_PATHS.subscriptionPortalPages.mspStackReport(mockMspId), {
      state: {
        forView: true,
        mspId: mockMspId,
      }
    });
  };

  const handleReportViewClick = (mspId, reportId) => {
    navigate(ROUTE_PATHS.subscriptionPortalPages.mspStackReport(mspId), {
      state: {
        forView: true,
        mspId: mspId,
        passedReportId: reportId
      }
    });
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setSearchString(value);
  };

  const handleSortClick = () => {
    console.log("Sort clicked");
  };

  return (
    <div className={styles.section}>
      <div className="d-flex align-items-center justify-content-end">
        <img
          src="/images/actioncenter/folder.svg"
          alt=""
          className="mr-2"
        />
        <ReportSearchFilter
          searchValue={searchString}
          searchOnChange={handleInputChange}
          searchOnCross={() => {
            handleInputChange({ target: { value: "" } });
          }}
          searchInputRef={SearchInput}
          onSortClick={handleSortClick}
          onReportClick={handleReportAdd}
        />
      </div>
      <div className={styles.tableContainer}>
        <MspReportTable
          tableData={mockTableData}
          mspId={mockMspId}
          onReportAdd={handleReportAdd}
          onReportViewClick={handleReportViewClick}
          searchValue={searchString}
        />
      </div>
    </div>
  )
}

export default StackReportSection;
